<template>
  <div>
    <slot></slot>
    <tooltip :content="tooltipContent()" />
  </div>
</template>

<script>
export default {
  name: "ModuleLegend",
  props: {
    module: {
      type: Object,
    },
  },
  data() {
    return {
      legend: [
        { type: "LINE", color: "RED", label: "Operating range" },
        { type: "LINE", color: "BLUE", label: "Performance range" },
        { type: "DOT", color: "BLUE", label: "Operating point" },
      ],
    };
  },
  computed: {
    legendProps() {
      let iMax = Math.round(this.module.iModTcMax * 1000);
      let iLife = Math.round(this.module.iModTcIltMax * 1000);
      let tcLife = this.module.tcIltMid;
      let tcMax = this.module.tcIMax;

      let lpObj = [];
      if (iMax !== null) {
        lpObj.push({
          type: "LINE",
          color: "BLUE",
          label: `I life ${iLife} (mA)`,
        });
      }
      if (iMax !== null) {
        lpObj.push({ type: "LINE", color: "RED", label: `I max ${iMax} (mA)` });
      }
      if (tcLife !== null) {
        lpObj.push({
          type: "LINE",
          color: "BLUE",
          label: `Tc life ${tcLife} (℃)`,
        });
      }
      if (tcMax !== null) {
        lpObj.push({
          type: "LINE",
          color: "RED",
          label: `Tc max ${tcMax} (℃)`,
        });
      }
      return lpObj;
    },
  },
  methods: {
    firstHalfList(list) {
      if (list.length % 2 === 0) {
        return list.slice(0, list.length / 2);
      } else {
        return list.slice(0, list.length / 2 + 1);
      }
    },
    secondHalfList(list) {
      if (list.length % 2 === 0) {
        return list.slice(list.length / 2, list.length);
      } else {
        return list.slice(list.length / 2 + 1, list.length);
      }
    },
    getClasses(item) {
      let result = [];
      //Color classes
      switch (item.color) {
        case "RED":
          result.push("red");
          break;
        case "BLUE":
          result.push("blue");
          break;
        case "GREEN":
          result.push("green");
          break;
        case "ORANGE":
          result.push("orange");
          break;
        case "BLACK":
          result.push("black");
          break;
      }
      //Type classes
      switch (item.type) {
        case "LINE":
          result.push("line");
          break;
        case "DOT":
          result.push("dot");
          break;
        case "DOTTED":
          result.push("dotted");
          break;
      }
      return result;
    },
    tooltipContent() {
      let html = '<div class="legend"><ul>';

      for (let l of this.legend) {
        let color = l.color.toLowerCase();
        let type = l.type.toLowerCase();

        html += "<li>";
        html += '<span class="' + color + " " + type + '"></span>';
        html += '<div class="legend-label">' + l.label + "</div>";
        html += "</li>";
      }
      html += "</ul></div>";

      html += '<div class="legend"><ul>';
      for (let prop of this.legendProps) {
        let color = prop.color.toLowerCase();
        let type = prop.type.toLowerCase();

        html += "<li>";
        html += '<span class="' + color + " " + type + '"></span>';
        html += '<div class="legend-label">' + prop.label + "</div>";
        html += "</li>";
      }
      html += "</ul></div>";

      return html;
    },
  },
};
</script>

<style lang="scss">
.legend-padding {
  .easy-tooltip {
    position: absolute;
    right: 26px;
    top: 36px;
  }
}
</style>
